import React, { useState } from 'react';
import { Form, Modal, Row } from 'antd';
import { Button, Input, Typography } from 'components';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as loginService from 'services/login.service';
import { customMessages } from 'utils';

import { loginEvents } from 'utils/utility-functions';
import config from '../../config';

import CloseIcon from 'assests/icons/close.icon';
import formatter from 'string-format';
import * as GAEvent from 'utils/ga-event';
const { Link } = Typography;

const LoginForm = () => {
  const mUrl =
    'https://hizligiris.com.tr/hizligiris/oauth/authorize?client_id=' +
    config.mobileConnect.clientId +
    '&scope=openid%20phone&redirect_uri=' +
    config.mobileConnect.calbackUrl +
    '&nonce=' +
    window.crypto.getRandomValues(new Uint32Array(1))[0] +
    '&response_type=code&state=mobcon_login&prompt=login&max_age=3600&acr_values=3&display=page&ui_locales=tr&claims_locales=tr';
  let previousUrl = null;
  let windowObjectReference = null;

  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const [modalFastLogin, setModalFastLogin] = useState(false);
  const [mobileSignatureModal, setMobileSignatureModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const receiveMessage = (event) => {
    event.preventDefault();
    window.removeEventListener('message', (event) => receiveMessage(event));
    // Do we trust the sender of this message? (might be
    // different from what we originally opened, for example).
    const { data } = event;
    if (data === undefined || data === null) {
      return;
    }
    const result = JSON.parse(unescape(data));
    if (result.responseCode == 200) {
      dispatch({
        type: 'LOGIN',
        payload: result,
      });
      history.push({
        pathname: `/ReportsPage`,
      });
      GAEvent.gaEvent(GAEvent.MOBILE_LOGIN, GAEvent.SUCCESS);
    } else if (result.responseCode == 913) {
      history.push(`/SignUp`, { msisdn: result.token, newUser: true });
      GAEvent.gaEventError(
        GAEvent.MOBILE_LOGIN,
        GAEvent.ERROR,
        result.responseCode
      );
    } else {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(result.responseCode),
      });
      GAEvent.gaEventError(
        GAEvent.MOBILE_LOGIN,
        GAEvent.ERROR,
        result.responseCode
      );
    }

    window.removeEventListener('message', receiveMessage, false);
  };

  const openSignInWindow = (url, name) => {
    // remove any existing event listeners
    window.removeEventListener('message', receiveMessage, false);
    // window features
    const strWindowFeatures =
      'toolbar=no, menubar=no, width=600, height=700, top=100, left=100';

    if (windowObjectReference === null || windowObjectReference.closed) {
      /* if the pointer to the window object in memory does not exist
       or if such pointer exists but the window was closed */
      windowObjectReference = window.open(url, name, strWindowFeatures);
    } else if (previousUrl !== url) {
      /* if the resource to load is different,
       then we load it in the already opened secondary window and then
       we bring such window back on top/in front of its parent window. */
      windowObjectReference = window.open(url, name, strWindowFeatures);
      windowObjectReference.focus();
    } else {
      /* else the window reference must exist and the window
       is not closed; therefore, we can bring it back on top of any other
       window with the focus() method. There would be no need to re-create
       the window or to reload the referenced resource. */
      windowObjectReference.focus();
    }

    // add the listener for receiving a message from the popup
    window.addEventListener('message', receiveMessage, false);
    // assign the previous URL
    previousUrl = url;
  };

  return (
    <>
      <h3 className="section__title">Giriş Yap</h3>
      <Row className="margin-bottom-spacing-m">
        <p className="info-text--big">Turkcell Mobil İmza ile giriş yapın.</p>
      </Row>

      <Row className="margin-bottom-spacing-m">
        <div className="info-text--medium">
          Mesaj Üssü platformuna üye olduğunuz GSM Numaranız ve hattınıza
          kayıtlı Mobil Imzanız ile kimliğinizi doğruladıktan sonra işlemlerinize
          başlayabilirsiniz.
          <div>
            <a
              href="https://www.turkcell.com.tr/servisler/bilgi/turkcell-mobil-imza"
              target="_blank"
              rel="noopener noreferrer"
              className=""
              style={{ cursor: 'pointer' }}
            >
              Mobil İmza Nedir,
            </a>
            <a
              href="https://anindamobilimza.turkcell.com.tr/mobilimza"
              target="_blank"
              rel="noopener noreferrer"
              className=""
              style={{ marginLeft: '4px', cursor: 'pointer' }}
            >
              Mobil İmza Satın Al.
            </a>
          </div>
        </div>
      </Row>

      <Form
        form={form}
        name="login"
        onFinish={(values) => {
          loginService
            .checkLoginWhitelist(values.msisdn)
            .then((response) => {
              if (response && response.responseCode === 200) {
                history.push(`/Login2/${values.msisdn}`);
              } else {
                history.push(`/Login/${values.msisdn}`);
              }
            })
            .catch(() => {
              history.push(`/Login/${values.msisdn}`);
            });
        }}
        onFinishFailed={(event) =>
          console.log('onFinishFailed login form ==> ', event)
        }
      >
        <Form.Item
          name="msisdn"
          messageVariables={{ label: 'GSM Numarası' }}
          rules={[
            { required: true, message: 'GSM Numarası gereklidir.' },
            {
              pattern: /^5\d{9}$/,
              message:
                'GSM Numarası 5 ile başlayan 10 haneli olmalıdır. (5XXXXXXXXX)',
            },
          ]}
          className="login-form-item margin-bottom-spacing-m"
          style={{
            marginBottom: '24px',
          }}
        >
          <Input autoComplete="off" label="GSM Numaranız" maxLength={10} />
        </Form.Item>

        <div className="login-form-hint">
          Mobil imzanızın tanımlı olduğu, 10 haneli cep telefonu numaranızı
          giriniz. 5XXXXXXXXX
        </div>

        <Form.Item className="login-form-button-item">
          <Row justify="center">
            <Button
              type="primary"
              htmlType="submit"
              shape="round"
              className="login-button"
              block
            >
              Giriş Yap
            </Button>
          </Row>
        </Form.Item>
      </Form>

      <Modal
        title={
          <span
            style={{
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              display: 'block',
              paddingLeft: '24px',
            }}
          >
            Mobil İmza Nedir, Nasıl Alınır?
          </span>
        }
        visible={mobileSignatureModal}
        closeIcon={<CloseIcon />}
        onCancel={() => setMobileSignatureModal(false)}
        footer={
          <div className="modal-action">
            <Button
              shape="confirm"
              type="primary"
              onClick={() => setMobileSignatureModal(false)}
            >
              Tamam
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: '24px' }}>
          <h4
            style={{
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '12px',
              color: '#333',
            }}
          >
            Mobil İmza Nedir?
          </h4>
          <div className="login-form-hint">
            Mobil İmza, cep telefonu ve GSM SIM kart kullanılarak 5070 sayılı
            Elektronik İmza Kanunu ve ilgili yasal mevzuata uygun olarak ıslak
            imza niteliğinde güvenli bir biçimde elektronik imza işlemi
            yapılmasına imkân sağlayan uygulamadır. Mobil İmza ücretlendirmesi
            hakkında Turkcell'den bilgi edinebilirsiniz.
          </div>
        </div>

        <div>
          <h4
            style={{
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '12px',
              color: '#333',
            }}
          >
            Mobil İmza Nasıl Alınır?
          </h4>
          <p style={{ marginBottom: '12px' }}>
            Mobil elektronik imza GSM işletmecileri tarafından sunulan bir
            hizmettir. Mobil imza aboneliği üç aşamadan oluşur: Ön başvuru,
            Başvuru ve Aktivasyon. Bu hizmeti operatörünüze başvurarak ayrıntılı
            bilgi alabilir ve başvuru yaparak bir mobil imza edinebilirsiniz.
          </p>

          <a
            href="https://www.turkcell.com.tr/servisler/bilgi/turkcell-mobil-imza"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontWeight: '500',
            }}
          >
            Turkcell Mobil İmza
          </a>
        </div>
      </Modal>
    </>
  );
};

export default LoginForm;
